import {useEffect, useState} from "react";

import {EquipmentInfoTabs} from "../additional-data/ui/EquipmentInfoTabs.jsx";
import {HeaderInfo} from "../additional-data/ui/HeaderInfo/HeaderInfo.jsx";
import api from "../../api.js";
import {properties} from "@/properties.js";
import {Header} from "@/variants/index.js";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getSummaryValue} from "@/helpers.js";

export const EquipmentPage = ({onItemUpdate, getDocumentsList, documentsList, image, show, images, openImageModal}) => {
	const [data, setData] = useState({
		item: {},
		informationData: [],
		bomData: [],
		maint_works: [],
	});

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const operatorFromUrl = searchParams.get("operator") || "";
	const materialFromUrl = searchParams.get("material") || "";

	const headerKeys = Header.getEquipmentHeaderKeys();

	useEffect(() => {
		let url = properties.apiUrl;
		if (sessionStorage.getItem("item_url") && sessionStorage.getItem("item_url") !== null) {
			url = sessionStorage.getItem("item_url");
		} else if (localStorage.getItem("item_url") && localStorage.getItem("item_url") !== null) {
			url = localStorage.getItem("item_url");
			sessionStorage.setItem("item_url", url);
		}

		api.post(`/item/full?material=${materialFromUrl}&operator=${encodeURIComponent(operatorFromUrl)}`, {url}, { omitGlobalError: true })
			.then(json => {
				const firstItem = json.data.item[0];

				const infColumns = ["components", "identical_boms", "pm_plans", "pm_executed", "cm_executed", "ratio"];

				setData(prev => ({
					...prev,
					item: firstItem,
					informationData: getSummaryValue(infColumns, firstItem),
				}));

				onItemUpdate(firstItem.part_number);
			})
			.catch(() => {
				if (!properties.isDebug) {
					navigate(`/search?search=${materialFromUrl}`);
				}
			});
	}, [operatorFromUrl, materialFromUrl]);

	useEffect(() => {
		if (!data.item || !data.item.material) return;

		if (data.bomData.length === 0) {
			api.get(
				`/get/equipment-materials?operator=${encodeURIComponent(operatorFromUrl)}&material=${materialFromUrl}`,
			)
				.then(json => {
					const bomDataResponse = json.data["materials"] || [];

					setData(prev => ({
						...prev,
						bomData: bomDataResponse,
					}));
				})
				.catch(error => console.log(error));
		}

		const sortField = data.item[properties.plansMappingKey];

		api.get(`/get/maint-works?sort=${sortField}`)
			.then(json => {
				const maintWorksDataResponse = json.data["materials"] || [];

				setData(prev => ({
					...prev,
					maint_works: maintWorksDataResponse,
				}));
			})
			.catch(error => console.log(error));
	}, [data.item.material]);

	const item = {...data.item};
	if (item && !item.hasOwnProperty("raw")) item.raw = item.description;

	return (
		<div data-testid="equipment-page-container">
			<HeaderInfo
				image={image}
				item={item}
				headerColumns={headerKeys}
				images={images}
				handleModalOpen={() => openImageModal()}
				showEdit={show}
				data-testid="equipment-page-header-info"
			/>

			<EquipmentInfoTabs
				item={item}
				updateDocsTable={getDocumentsList}
				documentsList={documentsList}
				maint_works={data.maint_works}
				bomData={data.bomData}
				data-testid="equipment-page-info-tabs"
			/>
		</div>
	);
};
